module.exports = __webpack_public_path__ + "img/submenu02.69aa4dd2.png";